//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React from 'react';
import styled from 'styled-components';

//  -- Constants ----------------------
import COLOR from 'utils/constants/color';


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Wrapper = styled.div`
    align-items: center;
    background-color: ${p=>p.bgColor?p.bgColor:COLOR.green200};
    border-radius: 3px;
    color: ${COLOR.white};
    display: inline-flex;
    fill: ${COLOR.white};
    flex-direction: row;
    fill: ${COLOR.white};
    font-size: ${p => p.fontSize ? `${p.fontSize}px` : '10px'};
    font-weight: 600;
    line-height: 15px;
    margin-right: 4px;
    padding: 3px 7px 2px 5px;
    text-transform: uppercase;
    height: ${p => p.height ? `${p.height}px` : "auto"};
    gap: ${p => p.gap ? `${p.gap}px` : "0px"};
`;


//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Tag
//
//  -- Description
//  Tag component for helping draw attention or displaying something that is
//  important
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  <Tag>
//      children
//  </Tag>
//
const Tag = ({ children, fontSize , height  , bgColor , gap }) => (
    <Wrapper fontSize={fontSize} height={height} bgColor={bgColor} gap={gap} >
        {children}
    </Wrapper>
);


export default Tag;